import EnvironmentalStatusBadge from "./EnvironmentalStatusBadge";

interface GreenAreaCardProps {
  item: {
    id: string;
    nome: string;
    tipo: string;
    bairro: string;
    municipio: string;
    uf: string;
    areaHa: number;
    arvoresCadastradas: number;
    arvoresRiscoCritico: number;
    ultimaVistoria: string;
    status: string;
    co2eEstimado: number;
    responsavel: string;
  };
  onViewDetail: (item: any) => void;
}

export default function GreenAreaCard({ item, onViewDetail }: GreenAreaCardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 hover:border-background-300/60 transition-all duration-200 p-5 group cursor-pointer" onClick={() => onViewDetail(item)}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground-900 font-heading truncate">{item.nome}</h4>
          <p className="text-xs text-foreground-500 mt-0.5">{item.tipo} · {item.bairro} — {item.municipio}/{item.uf}</p>
        </div>
        <EnvironmentalStatusBadge status={item.status} />
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">Área</p>
          <p className="text-sm font-semibold text-foreground-900">{item.areaHa} ha</p>
        </div>
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">Árvores</p>
          <p className="text-sm font-semibold text-foreground-900">{item.arvoresCadastradas}</p>
        </div>
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">Risco Crítico</p>
          <p className={`text-sm font-semibold ${item.arvoresRiscoCritico > 0 ? "text-danger-600" : "text-foreground-900"}`}>{item.arvoresRiscoCritico}</p>
        </div>
        <div className="bg-background-50 rounded-lg p-2.5">
          <p className="text-[10px] text-foreground-500 uppercase tracking-wide">CO₂e Est.</p>
          <p className="text-sm font-semibold text-foreground-900">{item.co2eEstimado} t</p>
        </div>
      </div>

      <div className="flex items-center justify-between text-[11px] text-foreground-500 mb-3">
        <span><i className="ri-calendar-line mr-1"></i>Vistoria: {new Date(item.ultimaVistoria + "T00:00:00").toLocaleDateString("pt-BR")}</span>
        <span><i className="ri-user-line mr-1"></i>{item.responsavel.split(" — ")[0]}</span>
      </div>

      <div className="flex gap-1.5">
        <button
          onClick={(e) => { e.stopPropagation(); onViewDetail(item); }}
          className="flex-1 text-xs py-1.5 rounded-btn border border-primary-200 text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer font-medium"
        >
          <i className="ri-information-line mr-1"></i>Detalhe
        </button>
        <button onClick={(e) => e.stopPropagation()} className="text-xs px-2.5 py-1.5 rounded-btn border border-accent-200 text-accent-700 hover:bg-accent-50 transition-colors cursor-pointer">
          <i className="ri-map-pin-line"></i>
        </button>
        <button onClick={(e) => e.stopPropagation()} className="text-xs px-2.5 py-1.5 rounded-btn border border-background-200 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer">
          <i className="ri-file-chart-line"></i>
        </button>
      </div>
    </div>
  );
}